import React from 'react';
import { FaMobileAlt, FaKey, FaShieldAlt, FaChartBar, FaMoneyBillWave, FaTruck } from 'react-icons/fa';
import IndustryPageTemplate from './IndustryPageTemplate';

const featureIcons = {
  1: <FaMobileAlt />,
  2: <FaKey />,
  3: <FaShieldAlt />,
  4: <FaChartBar />,
  5: <FaMoneyBillWave />,
  6: <FaTruck />
};

const ElectronicsIndustryPage = () => {
  return (
    <IndustryPageTemplate 
      industryKey="electronics"
      gradient="#667eea 0%, #764ba2 100%"
      emoji=""
      featureIcons={featureIcons}
    />
  );
};

export default ElectronicsIndustryPage;

